<template>
  <section>
    <article>
      <h4>{{ nome }}</h4>
      <span>{{ cargo }}</span>
      <div class="status">
        <pulse-loader
          v-if="scaleStatus === 'validating'"
          :size="'0.5em'"
          title="Verificando disponibilidade da escala"
        />
        <font-awesome-icon
          v-else-if="scaleStatus === 'valid'"
          :icon="'calendar-check'"
          style="color:rgba(70, 140, 54, 0.8);"
          title="Todos os dias e horários estão disponiveis"
        />
        <button
          type="button"
          v-else-if="scaleStatus === 'invalid'"
          @click="show"
        >
          <font-awesome-icon
            :icon="'calendar-times'"
            title="Há conflitos de horário na escala deste funcionário, clique para saber mais!"
          />
        </button>
        <button type="button" v-else @click="verificaEscalaEhAtualizaItem">
          <font-awesome-icon
            :icon="'exclamation-triangle'"
            title="Não foi possivel verificar a disponibilidade, clique novamente aqui para verificar novamente!"
          />
        </button>
      </div>
    </article>
    <EmployeeItemScaleControl
      v-model="scale"
      @input="verificaEscalaEhAtualizaItem"
      @remove="$emit('clickClose')"
    />
    <button @click="$emit('clickClose')">
      ×
    </button>
  </section>
</template>

<script>
import EmployeeItemScaleControl from '@/components/Employee/ScaleControl'
import { request } from '@/request'

export default {
  inject: ['showAlert'],
  components: { EmployeeItemScaleControl },
  props: {
    employeeData: Object
  },
  created() {
    const { nome, cargo, scale, sshd, id } = this.employeeData
    this.nome = nome
    this.cargo = cargo
    this.scale = scale
    this.sshd = sshd
    this.colaborador_id = id
  },
  mounted() {
    this.verificaEscalaEhAtualizaItem()
  },
  data() {
    return {
      colaborador_id: '',
      sshd: '',
      nome: '',
      cargo: '',
      scale: [],
      scaleStatus: 'validating',
      scaleConflitos: []
    }
  },
  methods: {
    verificaEscalaEhAtualizaItem() {
      const { colaborador_id, scale } = this

      const timeList = {}
      scale
        .filter(({ active, times }) => active && times.length > 0)
        .forEach(({ date, times }) => {
          times.forEach(({ entrada, saida }) => {
            const timeKey = `${entrada}-${saida}`
            const data = date.toLocaleDateString('pt-BR', {
              month: '2-digit',
              day: '2-digit'
            })
            if (timeList.hasOwnProperty(timeKey)) {
              timeList[timeKey].datas.push(data)
            } else {
              timeList[timeKey] = {
                entrada,
                saida,
                datas: [data]
              }
            }
          })
        })

      const [{ referencia }] = scale
      const horarios_datas = Object.keys(timeList).map(key => ({
        ...timeList[key]
      }))

      this.scaleStatus = 'validating'

      request
        .post('escala/check', { referencia, colaborador_id, horarios_datas })
        .then(response => {
          if (Array.isArray(response.data)) {
            this.scaleConflitos = response.data
            this.scaleStatus = 'invalid'
          } else {
            this.scaleStatus = 'valid'
          }

          this.update(scale)
        })
        .catch(error => {
          console.log(error)
          this.scaleStatus = 'error'
        })
    },
    update(scale) {
      const { scaleStatus } = this
      this.$emit('updateItem', { scaleStatus, scale })
    },
    show() {
      const htmlContent = this.scaleConflitos.map(
        ({ data, uor, timeAlocado, timeConflitante }) => {
          return `<strong>${data}</strong> alocado na <strong>${uor} as ${timeAlocado}</strong>, o horário conflitante é <strong>${timeConflitante}</strong>`
        }
      )

      this.showAlert({
        title: 'Alerta',
        description:
          'Segue abaixo os conflitos informando os horários e as unidades que o mesmo já está alocado.',
        content: htmlContent
      })
    }
  }
}
</script>

<style scoped>
section {
  display: flex;
  flex-flow: row nowrap;
  padding: 5px 0px 5px 10px;
  border-bottom: 1px solid #d4d4d4;
}

section > * {
  margin-right: 5px;
}

article {
  flex: 6;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

article h4 {
  margin: 0px;
}

article div.status {
  display: flex;
  flex: 0;
  font-size: 21px;
}

article div.status button {
  background: none;
  border: 0;
  color: rgb(176, 0, 32, 0.8);
  cursor: pointer;
  opacity: 1;
}

article div.status button:hover {
  color: rgb(176, 0, 32);
}

div {
  flex: 2;
}

button {
  padding: 0;
  cursor: pointer;
  background: 0 0;
  border: 0;
  appearance: none;
  -webkit-appearance: none;
  float: right;
  font-size: 21px;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
  opacity: 0.2;
}

aside {
  flex: 0.1 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Employee/Item.vue